import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Landing from './containers/Landing/Landing';
// import SupportCenterPage from './components/SupportCenterPage';
// import ContactUsPage from './components/ContactUsPage';
// import TermsOfServicePage from './components/TermsOfServicePage';
// import PrivacyPolicyPage from './components/PrivacyPolicyPage';
// import DMCAPolicyPage from './components/DMCAPolicyPage';
// import CookiesPolicyPage from './components/CookiesPolicyPage';
// import Page404 from './components/Page404';

import Aux from './hoc/Aux';

export default (
  <Aux>
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route exact path="/:lang" component={Landing} />
      {/*<Route path="/:lang/support" component={SupportCenterPage} />*/}
      {/*<Route path="/:lang/contact-us" component={ContactUsPage} />*/}
      {/*<Route path="/:lang/terms-of-service" component={TermsOfServicePage} />*/}
      {/*<Route path="/:lang/privacy-policy" component={PrivacyPolicyPage} />*/}
      {/*<Route path="/:lang/dmca-policy" component={DMCAPolicyPage} />*/}
      {/*<Route path="/:lang/cookies-policy" component={CookiesPolicyPage} />*/}
      {/*<Route component={Page404} />*/}
    </Switch>
  </Aux>
);



// WEBPACK FOOTER //
// ./src/routes.js